import React from 'react'
import PropTypes from 'prop-types'

import { Text } from './styles'

const SubText = ({ children, style }) => <Text style={style}>{children}</Text>

SubText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  style: PropTypes.shape({}),
}

SubText.defaultProps = {
  style: null,
  children: ''
}

export default SubText
